import * as React from 'react';
import { useState, useEffect, MouseEvent } from 'react';
import { Modal, Row, Col, Alert } from 'react-bootstrap';
import axios, { AxiosError } from 'axios';

const VideoRibbon = () => {
  // State management
  const [videos, setVideos] = useState([
    {
      id: 1,
      title: "Donating on Behalf of a\nMicrosite Patient",
      title_spanish: "",
      subtitle: "",
      thumbnail: {
        //new images
      },
      video_url: "/api/placeholder/640/360",
      video_url_spanish: "/api/placeholder/640/360",
      bgColor: "primary"
    },
    {
      id: 2,
      title: "What is\nDonor Shield?",
      title_spanish: "",
      subtitle: "",
      thumbnail: "/api/placeholder/320/200",
      video_url: "/api/placeholder/640/360",
      video_url_spanish: "/api/placeholder/640/360",
      bgColor: "danger"
    },
    {
      id: 3,
      title: "What is the\nStandard Voucher Program?",
      title_spanish: "",
      subtitle: "",
      thumbnail: "/api/placeholder/320/200",
      video_url: "/api/placeholder/640/360",
      video_url_spanish: "/api/placeholder/640/360",
      bgColor: "danger"
    }
  ]);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [isSpanishVideo, setSpanishVideo] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [heading, setHeading] = useState('');
  const [intro, setIntro] = useState('');

  // Data fetching function
  const getData = async () => {
    try {
      setIsLoading(true);
      setError(null);
            
      const response = await axios.get(`${__API__}/microsite/videos`,);

      if (response.status != 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      //set header information
      setHeading(response.data.heading);
      setIntro(response.data.intro_paragraph);

      const data = response.data.videos;
      const formattedVideos = data.map(video => ({
        title: video.title,
        title_spanish: video.title_spanish,
        subtitle: video.title,
        description: video.description,
        video_url: video.video_url,
        video_url_spanish: video.video_url_spanish,
        bgColor: "danger",
        thumbnail: video.thumbnail
      }));
      
      setVideos(formattedVideos);
    } catch (err) {
      setError(err.message);
      console.error('Error fetching videos:', err);
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch data on component mount
  useEffect(() => {
    getData();
  }, []);

    const handleVideoClick = (video, isSpanish = false, e: MouseEvent<HTMLElement>) => {
    setSelectedVideo(video);
    setSpanishVideo(isSpanish);
    
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedVideo(null);
  };

  const PlayButton = () => (
    <div 
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '64px',
        height: '64px',
        background: 'rgba(0,0,0,0.5)',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <div
        style={{
          width: 0,
          height: 0,
          borderTop: '8px solid transparent',
          borderLeft: '12px solid white',
          borderBottom: '8px solid transparent',
          marginLeft: '4px'
        }}
      />
    </div>
  );

  // Show loading state
  if (isLoading) {
    return (
      <div className="container-fluid" style={{ backgroundColor: '#EBF5FF', padding: '2rem' }}>
        <div className="text-center">Loading videos...</div>
      </div>
    );
  }

  // Show error state
  if (error) {
    return (
      <div className="container-fluid" style={{ backgroundColor: '#EBF5FF', padding: '2rem' }}>
        <Alert>
          Error loading videos: {error}
        </Alert>
      </div>
    );
  }

  return (
    <div className="container" style={{ backgroundColor: '#EBF5FF', padding: '2rem', width: '100%' }}>
      <h2 className="text-center mb-4" style={{ fontWeight: 800 }}>
        {heading}
      </h2>
      <div className="container-fluid">
      <Row className="justify-content-center">
        {videos.map((video) => (
          <Col key={video.id} xs={12} md={4} className="mb-4">
            <Row 
             
              style={{ cursor: 'pointer', marginLeft: '5px', marginRight: '5px' }}
            >
                    <button
                        className="btn outline"
                        onClick={(e) => handleVideoClick(video, true, e)}
                        style={{ position: 'relative', borderTopLeftRadius: '8px', borderTopRightRadius: '8px', border: 'none', padding: "2px", boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
                        <img
                            src={(video.thumbnail as any)?.large}
                            alt={video.title}
                            style={{
                                width: '100%',
                                height: '200px',
                                objectFit: 'inherit',
                                borderTopLeftRadius: '8px',
                                borderTopRightRadius: '8px'
                            }}
                        />
                        <div style={{ position: 'absolute', inset: 0 }}>
                            <PlayButton />
                        </div>
                    </button>
            </Row>

            <Row style={{ textAlign: 'center', fontWeight: 800, fontSize: '20px' }}>
              
                    <button onClick={(e) => handleVideoClick(video, true, e)}
                        className="btn outline"
                        style={{
                            cursor: 'pointer',
                            whiteSpace: 'pre-wrap',
                            width: '85%',
                            marginTop: '20px',
                            marginBottom: '20px',
                            boxShadow: 'inset 1px 1px 3px rgba(0,0,0,0.15), inset -1px -1px 3px rgba(255,255,255,0.5)',
                            borderRadius: '6px'
                        }}
                    >
                        {video.title_spanish}
                    </button>
                <br />
            </Row>
          </Col>
        ))}
      </Row>
      </div>
      
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        backdrop="static"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
        }}
        className="w-100"
      >
    <div
      style={{
        width: '100%',
        margin: 'auto',
        backgroundColor: 'white',
        borderRadius: '8px',
        overflow: 'hidden',
      }}
    >
    <Modal.Header closeButton>
      <Modal.Title>{isSpanishVideo ? selectedVideo?.title_spanish : selectedVideo?.title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {selectedVideo && (
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
          <iframe
            src={isSpanishVideo ? selectedVideo.video_url_spanish : selectedVideo.video_url}
            title={selectedVideo.title}
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              borderRadius: '4px',
            }}
          />
        </div>
      )}
    </Modal.Body>
  </div>
</Modal>

    </div>
  );
};

export default VideoRibbon;